var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first"},[(_vm.cityDetail.cityName == '上蔡县')?_c('SCNews'):_c('News'),(_vm.cityDetail.havaLink)?_c('HTLink'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }